import React, { FC } from 'react';

import { Button } from '@nord/ui';
import { Loader } from '@nordvpn/teams.ui/lib/mui';

import { ISubmitProps as ICommonSubmitProps } from '../interfaces';

interface ISubmitProps extends ICommonSubmitProps {
  additionalDisabledCondition?: boolean;
  children?: React.ReactNode;
}

/**
 * @constructor
 * @deprecated use NewSubmit
 */

const Submit: FC<ISubmitProps> = ({
  loading = false,
  children = 'Submit',
  type = 'submit',
  color = 'blue',
  style = { minWidth: 120 },
  formProps: { submitting, pristine, hasSubmitErrors, dirtySinceLastSubmit } = {
    submitting: false,
    pristine: false,
    hasSubmitErrors: false,
    dirtySinceLastSubmit: false,
  },
  disabled = loading || submitting || pristine || (hasSubmitErrors && !dirtySinceLastSubmit),
  additionalDisabledCondition = null,
  ...rest
}) => (
  <Button
    disabled={disabled || additionalDisabledCondition}
    type={type}
    color={color}
    style={style}
    data-testid="submit-button"
    {...rest}
  >
    {loading || submitting ? <Loader /> : children}
  </Button>
);

export default Submit;
